var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavedStar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.2 21c-.2 0-.4 0-.5-.1L12 18.5l-4.6 2.4c-.2.1-.5.1-.7.1-.6-.1-1.1-.7-1-1.3l.8-5.1L2.8 11q-.3-.3-.3-.6c-.1-.7.4-1.3 1-1.4l5.1-.8L11 3.6c.1-.2.3-.4.5-.5q.45-.15.9 0c.3.1.5.3.7.6l2.3 4.6 5.1.7c.2 0 .5.2.7.3.5.5.4 1.2 0 1.6l-3.7 3.6.8 5.1c.1.7-.4 1.3-1 1.3z",
  className: "st0"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavedStar);
export default ForwardRef;